"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radioGroup = _interopRequireDefault(require("../radio-group"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Rating = (
/*#__PURE__*/
0, _styledBase.default)(function (props) {
  return (0, _core.jsx)(_radioGroup.default, _extends({
    labelBottom: true
  }, props));
}, {
  target: "eulrycn0"
})(process.env.NODE_ENV === "production" ? {
  name: "1mcqp3e",
  styles: "max-width:400px;min-width:300px;"
} : {
  name: "1mcqp3e",
  styles: "max-width:400px;min-width:300px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mb3JtLWlucHV0cy9yYXRpbmcvaW5kZXguanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV0UiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2Zvcm0taW5wdXRzL3JhdGluZy9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjb21wb3NlLCBzZXREaXNwbGF5TmFtZSwgc2V0UHJvcFR5cGVzLCB3aXRoSGFuZGxlcnMsIHdpdGhTdGF0ZSB9IGZyb20gJ3JlY29tcG9zZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5pbXBvcnQgUmFkaW9Hcm91cCBmcm9tICcuLi9yYWRpby1ncm91cCc7XG5cbmNvbnN0IFJhdGluZyA9IHN0eWxlZChwcm9wcyA9PiAoXG4gIDxSYWRpb0dyb3VwXG4gICAgbGFiZWxCb3R0b209e3RydWV9XG4gICAgey4uLnByb3BzfSAvPlxuKSlgXG4gIG1heC13aWR0aDogNDAwcHg7XG4gIG1pbi13aWR0aDogMzAwcHg7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjb21wb3NlKFxuICBzZXRQcm9wVHlwZXMoe1xuICAgIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgICBkaXNhYmxlZDogUHJvcFR5cGVzLmJvb2wsXG4gICAgZ3JvdXBMYWJlbDogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICAgIGhpZGVHcm91cExhYmVsOiBQcm9wVHlwZXMuYm9vbCxcbiAgICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmNcbiAgfSksXG4gIHdpdGhTdGF0ZSgnb3B0aW9ucycsICdzZXRPcHRpb25zJywgW1xuICAgIHsgbGFiZWw6IDAsIGNoZWNrZWQ6IGZhbHNlIH0sXG4gICAgeyBsYWJlbDogMSwgY2hlY2tlZDogZmFsc2UgfSxcbiAgICB7IGxhYmVsOiAyLCBjaGVja2VkOiBmYWxzZSB9LFxuICAgIHsgbGFiZWw6IDMsIGNoZWNrZWQ6IGZhbHNlIH0sXG4gICAgeyBsYWJlbDogNCwgY2hlY2tlZDogZmFsc2UgfSxcbiAgICB7IGxhYmVsOiA1LCBjaGVja2VkOiBmYWxzZSB9LFxuICAgIHsgbGFiZWw6IDYsIGNoZWNrZWQ6IGZhbHNlIH0sXG4gICAgeyBsYWJlbDogNywgY2hlY2tlZDogZmFsc2UgfSxcbiAgICB7IGxhYmVsOiA4LCBjaGVja2VkOiBmYWxzZSB9LFxuICAgIHsgbGFiZWw6IDksIGNoZWNrZWQ6IGZhbHNlIH0sXG4gICAgeyBsYWJlbDogMTAsIGNoZWNrZWQ6IGZhbHNlIH1cbiAgXSksXG4gIHdpdGhIYW5kbGVycyh7XG4gICAgb25DaGFuZ2U6ICh7IHNldE9wdGlvbnMsIG9uQ2hhbmdlIH0pID0+IChuZXdPcHRpb25zLCBlKSA9PiB7XG4gICAgICBzZXRPcHRpb25zKG5ld09wdGlvbnMpO1xuICAgICAgb25DaGFuZ2UoZS50YXJnZXQudmFsdWUpO1xuICAgIH1cbiAgfSksXG4gIHNldERpc3BsYXlOYW1lKCdSYXRpbmcnKSxcbikoUmF0aW5nKTtcbiJdfQ== */"
});

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  name: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  groupLabel: _propTypes.default.string.isRequired,
  hideGroupLabel: _propTypes.default.bool,
  onChange: _propTypes.default.func
}), (0, _recompose.withState)('options', 'setOptions', [{
  label: 0,
  checked: false
}, {
  label: 1,
  checked: false
}, {
  label: 2,
  checked: false
}, {
  label: 3,
  checked: false
}, {
  label: 4,
  checked: false
}, {
  label: 5,
  checked: false
}, {
  label: 6,
  checked: false
}, {
  label: 7,
  checked: false
}, {
  label: 8,
  checked: false
}, {
  label: 9,
  checked: false
}, {
  label: 10,
  checked: false
}]), (0, _recompose.withHandlers)({
  onChange: function onChange(_ref) {
    var setOptions = _ref.setOptions,
        _onChange = _ref.onChange;
    return function (newOptions, e) {
      setOptions(newOptions);

      _onChange(e.target.value);
    };
  }
}), (0, _recompose.setDisplayName)('Rating'))(Rating);

exports.default = _default;